import { useSelector, useDispatch } from 'react-redux';
import { closeGlobalPopup } from '../../redux/action';
import Popup from './Popup';

const GlobalPopup = ({ popupKey, title, children, onClose=() => {}, hideCloseButton = false, footer = null, disableClose = false }) => {
    const dispatch = useDispatch();
    const globalPopupKey = useSelector(state => state.user?.globalPopupKey);
    const isOpen = globalPopupKey && globalPopupKey === popupKey;

    const handleClose = () => {
        if (disableClose) return;
        dispatch(closeGlobalPopup());
        onClose();
    };

    const popupFooter = typeof footer === 'function' ? footer(handleClose) : footer;

    return (
        <Popup
            isOpen={isOpen}
            onClose={handleClose}
            title={title}
            hideCloseButton={hideCloseButton}
            disableClose={disableClose}
            footer={popupFooter}
        >
            {children}
        </Popup>
    );
};

export default GlobalPopup;
